<template>
  <div>
    <div class="card" style="max-width: 100%">
      <div class="card-header">
        <b>{{ title }} Intervención</b>
      </div>
      <div class="card-body text-dark">
        <router-link to="/grupo-eventos" class="btn btn-info"
          ><i class="mdi mdi-undo-variant"></i> Regresar</router-link
        ><br /><br />

        <form @submit.prevent="saveEventoRuta">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label>Nombre Intervención </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nombre del procedimiento a realizar"
                    v-model="eventos_rutas.evento"
                    :disabled="disabled"
                    required
                  />
                </div>
                <div class="col-md-12">
                  <label>Seleccione Flujograma de Atención:</label>
                  <Select2
                    v-model="eventos_rutas.ruta"
                    :options="options_rutas"
                  />
                </div>
                <div class="form-group col-sm-12">
                  <br /><br />
                  <center>
                    <button
                      type="submit"
                      class="btn btn-success"
                      :disabled="disabled"
                    >
                      Guardar
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { headers } from "../../../api/headers";
import { configApi } from "../../../api/configApi";
export default {
  name: "gruposeventos_crear",
  data: () => ({
    disabled: false,
    id_menu: 2,
    title: "Crear",
    options_rutas: [],
    eventos_rutas: {
      ruta: "",
      evento: "",
    },
  }),
  mounted() {
    this.getRutas();
    this.getEventoRuta();
  },
  computed: {},
  methods: {
    async getRutas() {
      return await this.axios
        .get(configApi + "grupo_eventos/listado_rutas", { headers })
        .then((response) => {
          let data = response.data.data;

          for (var i = 0, max = data.length; i < max; i += 1) {
            this.options_rutas.push({
              id: data[i].idruta,
              text: data[i].ruta,
            });
          }
        });
    },
    async getEventoRuta() {
      if (this.$route.params.id > 0) {
        return await this.axios
          .get(
            configApi + "grupo_eventos/eventos_rutas/" + this.$route.params.id,
            { headers }
          )
          .then((response) => {
            this.eventos_rutas.ruta = response.data.data.idruta;
            this.eventos_rutas.evento = response.data.data.proruta;

            if (this.$route.params.id > 0 && this.$route.params.accion == 0) {
              this.disabled = false;
              this.title = "Editar";
            }
          });
      }
    },
    async saveEventoRuta() {
      if (this.$route.params.id > 0 && this.$route.params.accion == 0) {
        return await this.axios
          .put(
            configApi + "grupo_eventos/eventos_rutas/" + this.$route.params.id,
            this.eventos_rutas,
            { headers }
          )
          .then((response) => {
            this.getEventoRuta();
            this.$Fun.alertaAccion("success", response.data.message, false);
          });
      } else {
        return await this.axios
          .post(configApi + "grupo_eventos/eventos_rutas", this.eventos_rutas, {
            headers,
          })
          .then((response) => {
            this.resetForm();
            this.$Fun.alertaAccion("success", response.data.message, false);
          });
      }
    },
    resetForm() {
      this.eventos_rutas.ruta = "";
      this.eventos_rutas.evento = "";
    },
  },
};
</script>
